@if (activationSent) {
<p>
  {{ "NEW_ACTIVATION_EMAIL_SENT" | translate }}
</p>
} @else {
<form [formGroup]="activationForm" (ngSubmit)="onSubmit()">
  <input
    type="email"
    formControlName="email"
    [placeholder]="'EMAIL' | translate"
  />
  @if (activationForm.get('email')?.touched) { @if
  (activationForm.get('email')?.hasError('required')) {
  <div class="error">
    {{ "EMAIL_REQUIRED" | translate }}
  </div>
  } @if (activationForm.get('email')?.hasError('email')) {
  <div class="error">
    {{ "INVALID_EMAIL" | translate }}
  </div>
  } } @if (error) {
  <div class="error">
    {{ error.error.error | translate }}
  </div>
  }
  <button type="submit">{{ "SEND_ACTIVATION_LINK" | translate }}</button>
</form>
}
